namespace TabAurous.Sales {
    export namespace ApprovalOutReturnAPIService {
        export const baseUrl = '~/api/Sales/ApprovalOutReturnAPI';

        export declare function Create(request: Serenity.SaveRequest<ApprovalOutReturnRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ApprovalOutReturnRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ApprovalOutReturnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalOutReturnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "~/api/Sales/ApprovalOutReturnAPI/Create",
            Update = "~/api/Sales/ApprovalOutReturnAPI/Update",
            Delete = "~/api/Sales/ApprovalOutReturnAPI/Delete",
            Retrieve = "~/api/Sales/ApprovalOutReturnAPI/Retrieve",
            List = "~/api/Sales/ApprovalOutReturnAPI/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ApprovalOutReturnAPIService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
